var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('box_1'),_c('box_2'),_c('box_3'),_c('box_4'),_c('box_5')],1)}
var staticRenderFns = []

export { render, staticRenderFns }